import Helmet from "react-helmet";


 const MyComponent = ({title}) => {
    return (
        <Helmet>
          <title>{title}</title>
        </Helmet>
    );
  };
  export default  MyComponent;